import React, { useEffect, useState } from "react";
import { Container, RelatedPost, RelatedPostContainer } from "./styled";
import * as contentful from "contentful";

const RelatedPosts = ({ tag, title }) => {
  const [articlesByTags, setArticlesByTags] = useState([]);

  //FUNCIONA, PERO HAY QUE CARGAR LA INFORMAICON DE NUEVO
  useEffect(() => {
    const client = contentful.createClient({
      space: "ynl21amwlp74",
      environment: "master", // defaults to 'master' if not set
      accessToken: `${process.env.REACT_APP_CONTENTFULL_AUTH}`,
    });

    client
      .getEntries({
        content_type: "blogPost",
        limit: 3,
        include: 10,
        "fields.postTags": tag,
      })
      .then((entry) => {
        setArticlesByTags(entry.items);
      })
      .catch((error) => console.log(error));
  }, []);

  const renderPortada = (article) => {
    if (
      article.fields.media &&
      article.fields.media.length > 0 &&
      article.fields.media[0].fields.title === "portada"
    ) {
      return (
        <div className="related-img-container">
          <img
            src={article.fields.media[0].fields.file.url}
            alt="Foto de portada"
          />
        </div>
      );
    } else {
      return (
        <div className="related-img-container">
          <img
            src="../../assets/article-default-portada.jpeg"
            alt="Foto de portada"
          />
        </div>
      );
    }
  };
  return (
    <Container>
      <h2>Más articulos</h2>
      <RelatedPostContainer>
        {articlesByTags.map(
          (article, i) =>
            article.fields.title !== title && (
              <a href={`/blog/article/${article.sys.id}`}>
                <RelatedPost key={i}>
                  <h3>{article.fields.title}</h3>
                  {renderPortada(article)}
                  <p>{article.fields.description}</p>
                </RelatedPost>
              </a>
            )
        )}
      </RelatedPostContainer>
    </Container>
  );
};
export default RelatedPosts;
